import { BCDataGrid } from '@bimser/components';
import { EContextMenuTargetTypes } from '../../../../../../entities';
import DataGrid2 from '../..';

type ContextMenuEvent = BCDataGrid.Entities.DataGridTypes.ContextMenuPreparingEvent & {
	event: React.MouseEvent<MouseEvent>;
};

export function onContextMenuOpen(this: DataGrid2, e: ContextMenuEvent) {
	if (e.row?.isEditing || e.target === 'header') {
		return;
	}

	const isRowOrContainer =
		this.contextMenuTarget === EContextMenuTargetTypes.Row && e.target == 'content';

	const isContainer = this.contextMenuTarget === EContextMenuTargetTypes.Container;

	const isColumnButton =
		this.contextMenuTarget == EContextMenuTargetTypes.Column && e.target === 'columnButton';

	if (isContainer || (e.rowIndex > -1 && (isColumnButton || isRowOrContainer))) {
		e.items = [];

		this.__onShowContextMenu(e.event, e);
	}

	e.event.stopPropagation();
}
